import {useState} from "react";
import DriverService from "../services/api";
import {useSnackbar} from "notistack";
import useDriverStore from "../zustand/useDriverStore";

const useDriver = () => {
    const {enqueueSnackbar} = useSnackbar();
    const { setIsSuccess } = useDriverStore();

    const [isFetchingDriverList, setFetchingDriverList] = useState(false);
    const [driverList, setDriverList] = useState([]);
    const [driverListByVehicleUid, setDriverListByVehicleUid] = useState([]);
    const [loading, setLoading] = useState(false);
    const [viewDriver, setViewDriver] = useState(null);

    const [orgDriverList, setOrgDriverList] = useState([]);
    const [isFetchingDriverDetails, setFetchingDriverDetails] = useState(false);
    const [driverDetails, setDriverDetails] = useState(null);
    const [filterDriverList, setFilterDriverList] = useState([]);

    
    const getDriverList = (parameters) => {
        setFetchingDriverList(true);
        setIsSuccess(false)
        DriverService.getDriverList(parameters).then((res) => {
            console.log("getDriverList data xxxx", res);

            if (res.data.success) {
                setFetchingDriverList(false);
                setDriverList(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching driver list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setDriverList([]);
            setFetchingDriverList(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }
    
    const getDriverListByVehicleUID = (parameters) => {
        setFetchingDriverList(true);

        DriverService.getDriverListByVehicleUID(parameters).then((res) => {
            console.log("getDriverListByVehicleUID data xxxx", res);

            if (res.data.success) {
                setDriverListByVehicleUid(false);
                setDriverList(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching driver list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setDriverListByVehicleUid(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

   
    const getOrganizationDriverList = (parameters) => {
        setFetchingDriverList(true);

        DriverService.getOrganizationDriverList(parameters).then((res) => {
            console.log("getOrganizationDriverList data xxxx", res);

            if (res.data.success) {
                setFetchingDriverList(false);
                setOrgDriverList(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching organization driver list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setOrgDriverList([]);
            setFetchingDriverList(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getViewDriver = (parameters) => {
        setFetchingDriverDetails(true);

        DriverService.getViewDriver(parameters).then((res) => {
            console.log("getViewDriver data xxxx", res);

            if (res.data.success) {
                setFetchingDriverDetails(false);
                setDriverDetails(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching driver details:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setDriverDetails([]);
            setFetchingDriverDetails(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const businessViewDriver = (parameters) => {
        setLoading(true)
        DriverService.businessViewDriver(parameters).then((res)=>{
            console.log('businessViewDriver xxxxxxxxxxxxx', res)
            setViewDriver(res.data.data)
            setLoading(false)
        }).catch((err)=>{
            console.log('businessViewDriver errrr', err)
            setLoading(false)
            const errorMessage = err?.response?.data?.error || err.message;

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateDriverStatus = (parameters, setOpen) => {
        setLoading(true);
        
        DriverService.updateDriverStatus(parameters).then((res)=>{
            console.log('updateDriverStatus xxxxxxxxxxxxx', res)
            setOpen(false)
            setLoading(false)
            setIsSuccess(true)
            enqueueSnackbar("Successfully updated", {
                variant: "success",
                autoHideDuration: 4000
            })
        }).catch((err)=>{
            console.log('updateDriverStatus errrr', err)
            setLoading(false)
            const errorMessage = err?.response?.data?.error || err.message;
            setIsSuccess(false)  
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const listDriverFilter = (parameters) => {
        setLoading(true)
        DriverService.listDriverFilter(parameters).then((res) => {
            console.log("listDriverFilter data xxxx", res);
            if (res.data.success) {
                setFilterDriverList(res.data.data);
                setLoading(false)
            } 

        }
        ).catch((error) => {
            console.error("Error fetching filtered driver list:", error);
            setLoading(false)
            const errorMessage = error?.response?.data?.error || error.message;
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        }
        )
    }

 
    return {
        isFetchingDriverList,
        driverList,
        getDriverList,

        getDriverListByVehicleUID,
        driverListByVehicleUid,

        getOrganizationDriverList,
        orgDriverList,

        getViewDriver,
        isFetchingDriverDetails,
        driverDetails,
        
        businessViewDriver, viewDriver,

        updateDriverStatus,
        loading,

        listDriverFilter,
        filterDriverList,
    }
}

export default useDriver